<template>
    <div class="section_top">
        <!-- <p class="top_title">{{title}}</p>
        <p class="top_content">{{content}}</p> -->
    </div>
</template>

<script>
export default {
    name: 'CTitle',
    props: {
        title: String,
        content: String
    }
}

</script>

<style lang="scss" scoped>
.section_top {

}
.top_title {
    margin: 0;
    font-size: 18px;
    color: #333;
    font-weight: bolder;
}
.top_content {
    font-size: 14px;
    color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/global/CTitle.vue